import { createRouter, createWebHistory } from 'vue-router'
import Home from './components/HomePage.vue'
import Detail from './components/GoodsDetail.vue' // 将要创建的新页面

const routes = [
    {
        path: '/',
        name: 'Home', 
        component: Home,
        meta: {
            keepAlive: true,
            title: 'PUBG选号网'
        }
    },
    { 
      path: '/detail', 
      name: 'Detail',
      component: Detail,
      meta: {
        title: '账号详情'
      }
     }
]

const router = createRouter({
  //history: createWebHistory(),
  history: createWebHistory('/pc/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 返回页面时恢复滚动位置
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router